<template>
<div>
  <div class="icons">
    <div class="media mp3">
      <div v-if="song.available_download_mp3">

        <div v-if="user">

          <a
             :class="'status-'+((!downloads['mp3'][song.id]) ? 'default' :downloads['mp3'][song.id])"
             :href="'/api/v1/download/song/' + user.id + '/' + song.id + '/mp3'"
             @click="onDownload($event, 'mp3')"
             ref="mp3">
            <span class="loading-status"></span>
            <img src="/themes/caramba/assets/images/mp3_on.svg" /><span class="active">Mp3</span>
          </a>

        </div>
        <div v-else>

          <a @click.prevent="openWarning($event,'mp3')" >
            <img src="/themes/caramba/assets/images/mp3_on.svg"/><span class="active">Mp3</span>
          </a>

        </div>

      </div>

      <div v-else><img src="/themes/caramba/assets/images/mp3_off.svg" /><span class="inactive">Mp3</span></div>

    </div>





    <div class="media mp3-backing">


      <div v-if="song.mp3_base != null && (song.available_users || song.available_download)">

        <div v-if="user && (song.available_users || (!song.available_users && song.available_download && user.is_pro))">

            <a
               :class="'status-'+((!downloads['mp3_base'][song.id]) ? 'default' :downloads['mp3_base'][song.id])"
               :href="'/api/v1/download/song/' + user.id + '/' + song.id + '/mp3_base'" @click="onDownload($event, 'mp3_base')" ref="mp3_base">
              <span class="loading-status"></span>
              <img src="/themes/caramba/assets/images/mp3_backing_on.svg" /><span class="active">Base mp3</span>
            </a>


        </div>
        <div v-else>
          <a @click.prevent="openWarning($event,'mp3_base')" ><img src="/themes/caramba/assets/images/mp3_backing_on.svg"/><span class="active">Base mp3</span></a>
        </div>


      </div>
      <div v-else>
        <img src="/themes/caramba/assets/images/mp3_backing_off.svg" /> <span class="inactive">Base mp3</span> <span></span>
      </div>

    </div>





    <div class="media midi-backing">

      <div v-if="song.mid != null && (song.available_users || song.available_download)">

        <div v-if="user && (song.available_users || (!song.available_users && song.available_download && user.is_pro))">

          <a
              :class="'status-'+((!downloads['mid'][song.id]) ? 'default' :downloads['mid'][song.id])"
              :href="'/api/v1/download/song/' + user.id + '/' + song.id + '/mid'" @click="onDownload($event, 'mid')" ref="mid">
            <span class="loading-status"></span>
            <img src="/themes/caramba/assets/images/midi_backing_on.svg" /><span class="active">Midi</span>
          </a>

        </div>
        <div v-else>
          <a @click.prevent="openWarning($event,'mid')" ><img src="/themes/caramba/assets/images/midi_backing_on.svg" /><span class="active">Midi</span></a>
        </div>


      </div>
      <div v-else>
        <img src="/themes/caramba/assets/images/midi_backing_off.svg" /><span class="inactive">Midi</span>
      </div>

    </div>

    <div class="media score">

      <div v-if="song.sheet != null && (song.available_users || song.available_download)">

        <div v-if="user && (song.available_users || (!song.available_users && song.available_download && user.is_pro))">

          <a
              :class="'status-'+((!downloads['sheet'][song.id]) ? 'default' :downloads['sheet'][song.id])"
              :href="'/api/v1/download/song/' + user.id + '/' + song.id + '/sheet'" @click="onDownload($event, 'sheet')" ref="sheet">
            <span class="loading-status"></span>
            <img src="/themes/caramba/assets/images/score_on.svg" /><span class="active">Spartito</span>
          </a>

        </div>
        <div v-else>
          <a @click.prevent="openWarning($event,'sheet')" ><img src="/themes/caramba/assets/images/score_on.svg" /><span class="active">Spartito</span></a>
        </div>


      </div>
      <div v-else>
        <img src="/themes/caramba/assets/images/score_off.svg" /><span class="inactive">Spartito</span>
      </div>

    </div>

    <div class="media lyrics">




      <div v-if="song.lyrics != null && (song.available_users || song.available_download)">

        <div v-if="user && (song.available_users || (!song.available_users && song.available_download && user.is_pro))">

          <a
              :class="'status-'+((!downloads['lyrics'][song.id]) ? 'default' :downloads['lyrics'][song.id])"
             :href="'/api/v1/download/song/' + user.id + '/' + song.id + '/lyrics'"
             @click="onDownload($event, 'lyrics')"
             ref="lyrics">
            <span class="loading-status"></span>
            <img src="/themes/caramba/assets/images/lyrics_on.svg" /><span class="active">Testo</span>
          </a>

        </div>
        <div v-else>
          <a @click.prevent="openWarning($event,'lyrics')" ><img src="/themes/caramba/assets/images/lyrics_on.svg" /><span class="active">Testo</span></a>
        </div>


      </div>
      <div v-else>
        <img src="/themes/caramba/assets/images/lyrics_off.svg" /><span class="inactive">Testo</span>
      </div>

    </div>

    <div class="warning" v-show="isDisplayingWarningMsg == true" :class="currentType" v-click-outside="closeWarning">

      <div v-if="user && user.is_blocked == 1">
              Il tuo account è temporaneamente bloccato. Contattaci a <a class="standard-link" href="mailto:edizionicaramba@caramba.it" >edizionicaramba@caramba.it</a> per informazioni
      </div>
      <div v-else>
        <div v-if="currentType=='mp3'">
          <p class="message">Attenzione! Questo contenuto è accessibile solo agli utenti registrati!</p>
          <router-link @click.prevent="closeWarning" to="/login" v-if="!user">Accedi</router-link>
        </div>

        <div v-else>
          <div v-if="!user">
            <p class="message">Attenzione! Questo contenuto è accessibile solo agli utenti registrati!</p>
            <router-link @click.prevent="closeWarning" to="/login" v-if="!user">Accedi</router-link>
          </div>

          <p class="message"
             v-else-if="user
                      && !song.available_users
                      && song.available_download
                      && !user.is_pro">

            Attenzione! Questo contenuto è disponibile solo per utenti professionisti!

          </p>
        </div>

      </div>

    </div>
  </div>
  <DownloadModalAlert />



  </div>
</template>

<script>

import Vue from 'vue';
import * as Cookies from 'js-cookie';
import axios from 'axios/dist/axios';
import ClickOutside from 'vue-click-outside'
import DownloadModalAlert from './DownloadModalAlert';


export default {
  props: ['user', 'song'],

  components: {

      DownloadModalAlert

  },

  data() {
    return {

        downloads:{
          mp3:{},
          mp3_base:{},
          mid:{},
          sheet:{},
          lyrics:{}
        },

        isDisplayingWarningMsg: false,
        isDisplayingDownloadAlert: false,
        downloadAlertMsg:null,

        currentType: ''

    }
  },

  methods: {

    download: function(type) {
      /*const _url = '/api/v1/download/song/' + this.user.id + '/' + this.song.id + '/' + type;
      this.$refs[type].href = _url;
      this.$refs[type].click();

      console.log("Let's download the MP3", _url);*/

    },




    onDownload: function(e, type) {
      var vm = this;
      if(this.user) {

          if (this.downloads && this.downloads[type] && this.downloads[type][this.song.id]) {


            e.preventDefault();
            return false;

          } else if (this.user.is_blocked && this.user.is_blocked == "1") {
              this.openWarning(e, type);

              e.preventDefault();

              return false;
          } else {

              this.currentType = type;
              this.download(this.currentType);
              this.downloads[type][this.song.id] = 'downloading';

              setTimeout(() => {

                  this.downloads[type][this.song.id] = 'downloaded';

                  this.$eventBus.$emit('download:show_alert', {msg: "File scaricato correttamente"});

                  this.$forceUpdate(); // WTF! Now it works!

              }, 1000);

          }




      }
    },


    openWarning: function(e, type) {

        this.isDisplayingWarningMsg = true;
        console.log("inside openWarning", this.isDisplayingWarningMsg);
        this.currentType = type;

    },


    closeWarning: function(e) {
      //this.download(this.currentType);
      //this.isDisplayingWarningMsg = false;
    }
  },

  directives: {
      ClickOutside
  }


}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.warning {
  position: absolute;
  top: 100%;
  transform: translate(0, 13px);
  left: 0;
  padding: 15px 5px 10px;
  text-align: center;
  background: var(--light_purple);

  p, a {
    font-size: 14px;
    line-height: 17px;
  }

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    transform: translate(-50%, 0);
    top: -10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--light_purple);
  }

  &.mp3::before {
    left: 10%;
  }

  &.mp3_base::before {
    left: 30%;
  }

  &.mid::before {
    left: 50%;
  }

  &.sheet::before {
    left: 70%;
  }

  &.lyrics::before {
    left: 90%;
  }

  a {
    display: inline-block;
    padding: 2px 7px;
    border: 1px solid;
    margin: 12px 0 5px;
    background: white;
  }
}
.warning a.standard-link{
	display: inline-block;
    padding: 0;
    border: none;
    margin: 0;
    background: transparent;
    font-size: 16px;
}
.icons {

  .media {

    a {
      position: relative;

      &.status-downloaded {
        pointer-events: none;
        img {
          opacity:.125;
        }
        &:before{
	        content: "";
	        display: block;
	        position: absolute;
	        width: 100%;
	        height: 27px;
	        background-image: url("/themes/caramba/assets/images/check.svg");
	        background-size: 28px auto;
	        background-position: center center;
	        background-repeat: no-repeat;
	        z-index: 99;
	        opacity: 1;
	        
	        
        }
      }

      &.status-downloading {
        pointer-events: none;

        .loading-status {
          opacity:1;
        }

        img {
          opacity:.125;
        }

      }

      .loading-status {
        position: absolute;
        display: inline-block;
        width: 45px;
        height: 45px;

        opacity:0;

      }
      .loading-status:after {
        content: " ";
        display: block;
        width: 20px;
        height: 20px;
        margin: auto;
        border-radius: 50%;
        border: 3px solid rgba(255,255,255,.85) ;
        border-color: rgba(255,255,255,.95)  transparent rgba(255,255,255,.85)  transparent;
        animation: lds-dual-ring 1.2s linear infinite;
        top: 6px;
        position: relative;
      }

      @keyframes lds-dual-ring {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }




    }

  }

}



</style>



// WEBPACK FOOTER //
// src/vue/components/AlbumDownloadsHandler.vue